import { render, staticRenderFns } from "./teststatisticks.vue?vue&type=template&id=517cd8ea&"
import script from "./teststatisticks.vue?vue&type=script&lang=js&"
export * from "./teststatisticks.vue?vue&type=script&lang=js&"
import style0 from "./teststatisticks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports